<template>
  <van-popup class="sdk-frame-shell" :value="value" :overlay="false" :lazy-render="false" get-container="body" :duration="0.12"
    position="center" @input="$emit('input', $event)">
    <iframe v-if="frameSrc && (value || !frameLoaded || lifecycleReady)" :key="src" ref="frame" :src="frameSrc" :aria-hidden="String(!value)" title="E兔玩服务中心" frameborder="0" scrolling="no" allowtransparency="true" @load="onFrameLoad"></iframe>
  </van-popup>
</template>

<script>
export default {
  name: 'SdkFrameShell',
  props: { value: Boolean, src: { type: String, required: true } },
  data() { return { frameLoaded: false, lifecycleReady: false } },
  computed: {
    frameSrc() {
      if (!this.src) return ''
      // Keep the opaque login query unchanged; add only our lifecycle opt-in.
      const url = new URL(this.src, window.location.href)
      if (!/(?:[?&])sdkHostManaged=1(?:&|$)/.test(url.hash)) url.hash += (url.hash.includes('?') ? '&' : '?') + 'sdkHostManaged=1'
      return url.href
    },
  },
  watch: {
    value() { this.$nextTick(this.syncVisibility) },
    src() { this.frameLoaded = false; this.lifecycleReady = false },
  },
  mounted() { window.addEventListener('message', this.onFrameMessage) },
  beforeDestroy() { window.removeEventListener('message', this.onFrameMessage) },
  methods: {
    onFrameLoad() { this.frameLoaded = true; this.syncVisibility() },
    syncVisibility() {
      const frame = this.$refs.frame
      if (!frame || !this.src) return
      frame.contentWindow.postMessage({ operation: 'sdkSurfaceVisibility', visible: this.value === true }, new URL(this.src, window.location.href).origin)
    },
    onFrameMessage(event) {
      const frame = this.$refs.frame
      if (!frame || event.source !== frame.contentWindow) return
      let origin
      try { origin = new URL(this.src, window.location.href).origin } catch (_) { return }
      if (event.origin !== origin) return
      if (event.data && event.data.operation === 'sdkSurfaceReady') { this.lifecycleReady = true; this.syncVisibility(); return }
      if (!this.value) return
      if (event.data && ['closeSdkPanel', 'closeMenu'].includes(event.data.operation)) this.$emit('input', false)
    },
  },
}
</script>

<style>
/* One fullscreen dim layer; card geometry belongs to the SDK inside the iframe. */
.sdk-frame-shell.van-popup.van-popup--center {
  position: fixed !important; inset: 0 !important;
  width: 100vw !important; height: 100vh !important; max-width: none !important; max-height: none !important;
  margin: 0 !important; padding: 0 !important; transform: none !important;
  border: 0 !important; border-radius: 0 !important; box-shadow: none !important;
  background: rgba(3, 9, 18, .24) !important;
  backdrop-filter: none !important; -webkit-backdrop-filter: none !important; overflow: hidden !important;
}
.sdk-frame-shell > iframe {
  display: block; width: 100%; height: 100%; margin: 0; padding: 0;
  border: 0; border-radius: 0; background: transparent !important; color-scheme: normal;
}
@supports (height: 100dvh) {
  .sdk-frame-shell.van-popup.van-popup--center { height: 100dvh !important; }
}
</style>
